export default {
	tabs: ["Depósito", "Historial"],
	History: {
		tabs: ["Revisión", "Éxito", "Rechazar"]
	},
	AccountAmount: "Monto de la cuenta",
	ContactCustomerService: "Contactar al Servicio al Cliente",
	NoCustomerService: "Servicio al Cliente Ocupado",
	tips: "Por favor, envía la calificación anterior antes de proceder con la siguiente calificación"
};
